export default "__VITE_ASSET__c1214c5e__"